import React, { FC, memo } from "react";

const DeleteRow: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 4.94118V12.7059C11.75 13.4206 11.1904 14 10.5 14H5.5C4.80964 14 4.25 13.4206 4.25 12.7059V4.94118M9.875 4.94118V4.29412C9.875 3.5794 9.31536 3 8.625 3H7.375C6.68464 3 6.125 3.5794 6.125 4.29412V4.94118M3 4.94118H13M6.75 7.52941V11.4118M9.25 7.52941V11.4118"
      stroke="#495A64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(DeleteRow);
